import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const CDN = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards';
const LABELS = [
  'A. Don',
  'B. Amar Akbar Anthony',
  'C. Sahib Bibi Aur Ghulam',
  'D. Dharam Veer',
  'E. Kis Kis Ko Pyaar Karoon',
  'F. Ghulam',
];
const PLAYER_SIDS = [1, 2, 3, 4, 5, 6];
const CARD_FACES = ['J', 'Q', 'K', 'A'];
const CARD_SIDS = [10, 11, 12, 13];

function findBySid(sub, sid) {
  return sub.find((s) => s.sid === sid || s.sid === String(sid));
}
function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

function MinMax({ max, wrapCol }) {
  const inner = (
    <div className={`teen1daycasino-container justify-content-end casino-min-max${wrapCol ? '' : ' w-100'}`}>
      <div>
        R:
        <span>100</span>
        {' - '}
        <span>{max}</span>
      </div>
    </div>
  );
  return wrapCol ? <div className="col-12">{inner}</div> : inner;
}

// Dulha Dulhan / Barati fancy: odds title + label back box with book sibling
function FancyText({ item, label, onBet, exposures }) {
  const book = bookOf(exposures, item?.nat, item?.sid);
  return (
    <div className="col-lg-4 col-6 bc-fancy">
      <div className="casino-box-row">
        <div className="casino-nation-name"><b>{item?.b ?? 0}</b></div>
        <div className="casino-bl-box">
          <div
            className={`back casino-bl-box-item${suspCls(item)}`}
            onClick={isSusp(item) ? undefined : () => onBet(item.sid, 'back', item.b, item)}
          >
            <span className="casino-box-odd">{label}</span>
          </div>
          {' '}
          <span className={`casino-book text-center ${bookCls(book)}`}>{fmtBook(book)}</span>
        </div>
      </div>
      {' '}
      <MinMax max="1L" />
    </div>
  );
}

// Red / Black suit box: two card-suit images + book sibling
function ColorBox({ item, suits, onBet, exposures }) {
  const book = bookOf(exposures, item?.nat, item?.sid);
  return (
    <div className="casino-bl-box">
      <div
        className={`back casino-bl-box-item casino-card-img${suspCls(item)}`}
        onClick={isSusp(item) ? undefined : () => onBet(item.sid, 'back', item.b, item)}
      >
        <span><img src={`${CDN}/${suits[0]}.png`} /> <img src={`${CDN}/${suits[1]}.png`} /></span>
      </div>
      {' '}
      <span className={`casino-book text-center ${bookCls(book)}`}>{fmtBook(book)}</span>
    </div>
  );
}

const BetTableBtable = memo(function BetTableBtable({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const players = PLAYER_SIDS.map((sid) => findBySid(sub, sid));
  const odd = findBySid(sub, 7);
  const red = findBySid(sub, 8);
  const black = findBySid(sub, 9);
  const dulha = findBySid(sub, 14);
  const barati = findBySid(sub, 15);
  const cardItems = CARD_SIDS.map((sid) => findBySid(sub, sid));
  const cardsOdds = cardItems[0]?.b ?? 0;

  return (
    <>
      {/* Desktop players: 6 col-4 boxes */}
      <div className="row row5 d-none-small">
        {players.map((item, i) => {
          const book = bookOf(exposures, item?.nat, item?.sid);
          return (
            <div key={i} className="col-4">
              <div className="casino-box-row">
                <div className="casino-nation-name"><b>{LABELS[i]}</b></div>
                <div className="casino-bl-box">
                  <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
                    <span className="casino-box-odd">{item?.b ?? 0}</span>
                  </div>
                  <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
                    <span className="casino-box-odd">{item?.l ?? 0}</span>
                  </div>
                </div>
                <div className={`casino-book text-center ${bookCls(book)}`}>{fmtBook(book)}</div>
              </div>
            </div>
          );
        })}
        <MinMax max="1L" wrapCol />
      </div>

      {/* Mobile players: 6 boxes + Odd */}
      <div className="row row5 d-none-big">
        {players.map((item, i) => {
          const book = bookOf(exposures, item?.nat, item?.sid);
          return (
            <div key={i} className="casino-bl-box">
              <div className="casino-bl-box-item casino-odds-name">
                <b>{LABELS[i]}</b>
                {' '}
                <span className={`float-right ${bookCls(book)}`}>{fmtBook(book)}</span>
              </div>
              <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
                <span className="casino-box-odd">{item?.b ?? 0}</span>
              </div>
              <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
                <span className="casino-box-odd">{item?.l ?? 0}</span>
              </div>
            </div>
          );
        })}
        <MinMax max="1L" />
        {(() => {
          const book = bookOf(exposures, odd?.nat, odd?.sid);
          return (
            <div className="casino-bl-box">
              <div className="casino-bl-box-item casino-odds-name">
                <b>Odd</b>
                {' '}
                <span className={`float-right ${bookCls(book)}`}>{fmtBook(book)}</span>
              </div>
              <div className={`back casino-bl-box-item${suspCls(odd)}`} onClick={isSusp(odd) ? undefined : () => handleBet(odd.sid, 'back', odd.b, odd)}>
                <span className="casino-box-odd">{odd?.b ?? 0}</span>
              </div>
              <div className={`lay casino-bl-box-item${suspCls(odd)}`} onClick={isSusp(odd) ? undefined : () => handleBet(odd.sid, 'lay', odd.l, odd)}>
                <span className="casino-box-odd">{odd?.l ?? 0}</span>
              </div>
            </div>
          );
        })()}
        <MinMax max="1L" />
      </div>

      {/* Odd (desktop) + Dulha Dulhan + Barati */}
      <div className="row row5">
        <div className="col-lg-4 col-12 d-none-small">
          {(() => {
            const book = bookOf(exposures, odd?.nat, odd?.sid);
            return (
              <div className="casino-box-row">
                <div className="casino-nation-name"><b>Odd</b></div>
                <div className="casino-bl-box">
                  <div className={`back casino-bl-box-item${suspCls(odd)}`} onClick={isSusp(odd) ? undefined : () => handleBet(odd.sid, 'back', odd.b, odd)}>
                    <span className="casino-box-odd">{odd?.b ?? 0}</span>
                  </div>
                  <div className={`lay casino-bl-box-item${suspCls(odd)}`} onClick={isSusp(odd) ? undefined : () => handleBet(odd.sid, 'lay', odd.l, odd)}>
                    <span className="casino-box-odd">{odd?.l ?? 0}</span>
                  </div>
                </div>
                <div className={`casino-book text-center ${bookCls(book)}`}>{fmtBook(book)}</div>
                <MinMax max="1L" />
              </div>
            );
          })()}
        </div>

        <FancyText item={dulha} label="Dulha Dulhan K-Q" onBet={handleBet} exposures={exposures} />
        <FancyText item={barati} label="Barati J-A" onBet={handleBet} exposures={exposures} />
      </div>

      {/* Red/Black suits + Cards J-Q-K-A */}
      <div className="row row5">
        <div className="col-lg-6 col-12 aaa-oe">
          <div className="casino-box-row">
            <div className="casino-bl-box"><b>{red?.b ?? 0}</b></div>
            <div className="casino-bl-box"><b>{black?.b ?? 0}</b></div>
          </div>
          <div className="casino-box-row">
            <ColorBox item={red} suits={['heart', 'diamond']} onBet={handleBet} exposures={exposures} />
            <ColorBox item={black} suits={['spade', 'club']} onBet={handleBet} exposures={exposures} />
          </div>
          <MinMax max="1L" />
        </div>

        <div className="col-lg-6 col-12">
          <div className="text-center w-100">
            <div className="casino-bl-box">
              <div className="casino-bl-box-item"><b>Cards {cardsOdds}</b></div>
            </div>
          </div>
          <div className="casino-cards text-center mt-1">
            {CARD_FACES.map((face, i) => {
              const item = cardItems[i];
              const book = bookOf(exposures, item?.nat, item?.sid);
              return (
                <div key={face} className="casino-card-item" onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
                  <div className={`card-image${suspCls(item)}`}>
                    <img src={`${CDN}/${face}.png`} />
                  </div>
                  {' '}
                  <div className={`casino-book text-center ${bookCls(book)}`}>{fmtBook(book)}</div>
                </div>
              );
            })}
          </div>
          <MinMax max="25K" />
        </div>
      </div>
    </>
  );
});

export default BetTableBtable;
